import React, { Component } from 'react';

//import Siren from '../../assets/images/siren.png';
import './app-error.less';
export default class AppError extends Component {
  constructor(props) {
    super(props);
    const {
      error
    } = props;
    switch (error) {
      case 'path':
        this.state = {
          hasError: true,
          errorText: 'Invalid URL. Please check your URL and try again.'
        };
        break;
      default:
        this.state = {
          hasError: false,
          errorText: ''
        };
        break;
    }
  }
  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
      errorText: `${error} ${info.componentStack}`
    });
  }
  render() {
    const {
      hasError,
      errorText
    } = this.state;
    if (hasError) {
      return /*#__PURE__*/React.createElement("div", {
        className: "error-page"
      }, /*#__PURE__*/React.createElement("div", {
        className: "error-container"
      }, /*#__PURE__*/React.createElement("img", {
        src: null /* Siren */
      }), /*#__PURE__*/React.createElement("h1", null, "Uh-oh!"), /*#__PURE__*/React.createElement("h2", null, "We seem to be having difficulties"), /*#__PURE__*/React.createElement("p", null, errorText)));
    }
    return this.props.children;
  }
}
//# sourceMappingURL=app-error.js.map